import React from 'react'
import { css } from '@emotion/core'

type Props = {
  onClick: () => void
}
export const EditIcon: React.FC<Props> = ({ onClick }) => {
  return (
    <div css={buttonStyle}>
      <img src={require('@/static/images/edit.svg')} className="icon" onClick={onClick} />
    </div>
  )
}

const buttonStyle = css({
  display: 'flex',
  '.icon': {
    width: 30,
    cursor: 'pointer',
  },
})
